import { Observable, Subscription } from 'rxjs/Rx';

export class PgRecorder {
    context: AudioContext;
    audioInput: any;
    recorder: ScriptProcessorNode;
    analyser: AnalyserNode;
    mediaRecorder: MediaRecorder;
    recordingChunks = [];
    onStopCallback: Function;

    constructor(stream: any) {
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.ondataavailable = (e) => {
            this.recordingChunks.push(e.data);
        }

        this.context = new AudioContext();
        this.audioInput = (this.context as any).createMediaStreamSource(stream);
        this.recorder = this.context.createScriptProcessor(4096, 1, 1);

        this.analyser = this.context.createAnalyser();
        this.analyser.smoothingTimeConstant = 0.3;
        this.analyser.fftSize = 1024;
    }

    static create(loggerService: PgRendererDto.LoggerService): Promise<PgRecorder> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                //log available devices
                navigator.mediaDevices.enumerateDevices()
                    .then((devices) => {
                        devices.forEach((device: MediaDeviceInfo) => {
                            loggerService.reportDebugInfo("enumerateDevices", `${device.kind}: ${device.label} id = ${device.deviceId}`);
                        });
                    })
                    .catch(e => {
                        loggerService.reportError("enumerateDevices", {
                            name: e.name,
                            message: e.message
                        });
                    });

                //todo: remove casting to Promise<MediaStream> after typescript 2.1 fix this issue
                //https://github.com/Microsoft/TypeScript/issues/10242
                (navigator.mediaDevices.getUserMedia({ audio: true }) as Promise<MediaStream>)
                    .then(stream => {
                        if (loggerService) {
                            loggerService.reportDebugInfo(PgRecorder.name, `getUserMedia: MediaStream Id: ${stream.id}`);
                        }
                        resolve(new PgRecorder(stream));
                    })
                    .catch((e: MediaStreamError) => {
                        reject(e);
                        if (loggerService) {
                            loggerService.reportError(PgRecorder.name, {
                                name: e.name,
                                message: e.message
                            });
                        }
                    });
            }, 400);
        });
    }

    start(onStopCallback: Function) {
        this.audioInput.connect(this.analyser);
        this.analyser.connect(this.recorder);
        this.audioInput.connect(this.recorder);
        this.recorder.connect(this.context.destination);
        this.onStopCallback = onStopCallback;
        this.mediaRecorder.onstop = () => {
            if (this.onStopCallback){
                this.onStopCallback();
            }
        }
        this.mediaRecorder.start(1000);
    }

    stop() {
        this.analyser.disconnect();
        this.audioInput.disconnect();
        this.recorder.disconnect();
        this.mediaRecorder.stop();
    }

    getBlob(): Blob {
        const blob = new Blob(this.recordingChunks);
        this.recordingChunks = [];
        return blob;
    }

    play(audio: any) {
        audio.src = window.URL.createObjectURL(this.getBlob());
    }

    export(callback) {
        const url = window.URL.createObjectURL(this.getBlob());
        callback(url);
    }

    getInputActivityLevel(): number {
        const array = new Uint8Array(this.analyser.frequencyBinCount);
        this.analyser.getByteFrequencyData(array);
        let values = 0;

        const length = array.length;
        for (let i = 0; i < length; i++) {
            values += array[i];
        }
        const average = values / length;
        return average;
    }

}




// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/audio-recording/pg-recorder.ts